/**
 * The lever's input from the editor: the container's prompt groups (names
 * from the catalog, scores from the live ranking) or the example's, and how
 * many of today's drops get fresh AI texts (a sample day when none).
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenTextRankingPreview } from '@trafficpulse/shared';

import { useTextPromptGroups } from '@/features/campaign-texts/hooks/useTextPromptGroups';
import { optionLabelForGroup } from '@/features/campaign-texts/utils/group-tree.utils';

import type { TodayFacts } from '../today/kind-facts';
import { type LeanGroup, leanGroupsFor, type LeanView, SAMPLE_DROPS } from './lean-rows';

export function useLeanView(textGroupIds: string[], ready: DropGenTextRankingPreview | null, today: TodayFacts | null): LeanView {
  const catalog = useTextPromptGroups().data ?? [];
  const ranked = new Map((ready?.groups ?? []).map((g) => [g.groupId, g]));
  const own: LeanGroup[] = textGroupIds.map((id) => {
    const g = catalog.find((row) => row.id === id);
    const name = g ? optionLabelForGroup(g, catalog) : (ranked.get(id)?.groupName ?? `${id.slice(0, 8)}…`);
    return { id, name, score: ranked.get(id)?.score ?? null };
  });
  const example = ready?.example?.groups.map((g) => ({ id: g.groupId, name: g.groupName, score: g.score })) ?? null;
  const fresh = today ? today.drops.filter((d) => !d.locked && !d.copied && d.mix.ai > 0).length : 0;
  return { ...leanGroupsFor(own, example), drops: fresh > 0 ? fresh : SAMPLE_DROPS, today: fresh > 0 };
}
